/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from "react";


import { config } from "../../utils/config";
import "./CompanyList.css";
import { Spinner } from "react-bootstrap";
import EditClient from "./EditClient";

import { useNavigate } from "react-router-dom";
import { useCustomReactQuery } from "../../utils/useCustomReactQuery";
import { format } from "date-fns";
import { Eye, Pencil, Trash2 } from "lucide-react";
const columns = [
  { field: "companyName", title: "Company" },

  { field: "address", title: "Address" },
  { field: "contact", title: " Contact" },
  { field: "panNo", title: "Pan" },
  { field: "totalPc", title: "Status" },
  { field: "expireDate", title: "ExpireDate" },
  { field: "actions", title: "Actions" },
];

function CompanyList() {
  const navigate = useNavigate();
  const [isEdit, setIsEdit] = useState(false);
 
  const [records, error, isLoading] = useCustomReactQuery(
    `${config}/api/Company/CRUD`
  );
  if (records === undefined) {
    return <Spinner />;
  }
  const filteredRecords = records?.filter((record) => record.isFull === 1);
  const filteredRecord = records?.filter((record) => record.isActive === 1);
  const BlockRecord = records?.filter((record) => record.isActive === 0);

const ExpiredClient=()=>{
  const [record, error, isLoading] = useCustomReactQuery(
    `${config}/api/Company/CRUD`
  );
  if (record === undefined) {
    return <Spinner />;
  }
  return (
<div className="border-top p-1   d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column">
          {" "}
          <span>{record.companyName || ""}</span>
          <span>{record.address || ""}</span>
          <span>{record.contactNo || ""}</span>
            <span>{record.panNo || ""}</span>
          <div className="d-flex justify-content-between align-items-center">
          <i className={`bx bx-time ${daysRemaining < 0 ? 'text-danger' : 'text-success'}`}>
  {daysRemaining < 0 ? `${Math.abs(daysRemaining)} Days Ago` : `${daysRemaining} Days Left`}
</i>
          </div>
        </div>
        <div>
          <p className="mb-0 text-danger">
            Exp Date: {licenseExpiry.toLocaleDateString()}
          </p>
        </div>
      </div>
  )
}

  const ActiveCompanyList = ({ record }) => {
    const licenseExpiry = new Date(record.expireDate);
    const currentDate = new Date();
    const daysRemaining = Math.ceil(
      (licenseExpiry - currentDate) / (1000 * 60 * 60 * 24)
    );

    return (
      <div className="border-top p-1   d-flex justify-content-between align-items-center">
        <div className="d-flex flex-column">
          {" "}
          <span>{record.companyName || ""}</span>
          <span>{record.address || ""}</span>
          <span>{record.contactNo?record.contactNo:""}</span>
          <span>Pan: {record.panNo?record.panNo:""}</span>
          <div className="d-flex justify-content-between align-items-center">
          <i className={`bx bx-time ${daysRemaining < 0 ? 'text-danger' : 'text-success'}`}>
  {daysRemaining < 0 ? `${Math.abs(daysRemaining)} Days Ago` : `${daysRemaining} Days Left`}
</i>
          </div>
        </div>
        <div>
        <p className={`mb-0 ${daysRemaining < 0 ? 'text-danger' : 'text-success'}`}>
          {daysRemaining < 0 ? `Expired Date: ${licenseExpiry.toLocaleDateString()}` : `Expiry Date: ${licenseExpiry.toLocaleDateString()}`}
        </p>
        </div>
      </div>
    );
  };
  const filtered = records?.filter((record) => record.id === isEdit);

  const handleView = (data) => {
    console.log(data);
    navigate("/viewClient", { state: { data } });
  };
  const currentDate = new Date();
  return (
    <div className="p-2">
      <div className="row d-flex ">
        <div className="col-md-12">
          <div className="bg-white">
            <ul className="nav nav-tabs nav-fill" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                {" "}
                <button
                  className="nav-linki active"
                  id="faq_tab_1-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_1"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_1"
                  aria-selected="true"
                >
                  <div className="d-flex flex-column lh-lg">
                    {" "}
                    <i className="bx bx-store bx-sm"></i> <span>Company</span>{" "}
                  </div>
                </button>{" "}
              </li>
              <li className="nav-item" role="presentation">
                {" "}
                <button
                  className="nav-linki"
                  id="faq_tab_2-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_2"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_2"
                  aria-selected="false"
                >
                  <div className="d-flex flex-column lh-lg">
                    {" "}
                    <i className="bx bxs-shopping-bag bx-sm"></i>{" "}
                    <span>Active</span>{" "}
                  </div>
                </button>{" "}
              </li>
              <li className="nav-item" role="presentation">
                {" "}
                <button
                  className="nav-linki"
                  id="faq_tab_3-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_3"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_3"
                  aria-selected="false"
                >
                  <div className="d-flex flex-column lh-lg">
                    {" "}
                    <i className="bx bx-check-circle bx-sm"></i>{" "}
                    <span>Expired Client</span>{" "}
                  </div>
                </button>{" "}
              </li>
              <li className="nav-item" role="presentation">
                {" "}
                <button
                  className="nav-linki"
                  id="faq_tab_4-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#faq_tab_4"
                  type="button"
                  role="tab"
                  aria-controls="faq_tab_4"
                  aria-selected="false"
                >
                  <div className="d-flex flex-column lh-lg">
                    {" "}
                    <i className="bx  bx-x bx-sm"></i> <span>Block</span>{" "}
                  </div>
                </button>{" "}
              </li>
            </ul>
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade active show"
                id="faq_tab_1"
                role="tabpanel"
                aria-labelledby="faq_tab_1-tab"
              >
                {isEdit ? (
                  <EditClient
                    setIsEdit={setIsEdit}
                    data={records?.filter((x) => x.id === isEdit)[0] || null}
                  />
                ) : 
                //(
//                   <section className="content-client-table">
//                     <div className="data-table-info">
//                       <h4 className="data-table-title1">Client List</h4>
//                     </div>

//                     <div className="data-table-diagram1  scroll-y">
//                       <table className="table">
//                         <thead>
//                           <tr size="small">
//                             {columns?.map((th, index) => (
//                               <th key={index}>{th.title}</th>
//                             ))}
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {records?.map((dataItem) => {
//                             return (
//                               <tr
                               
//                                 size="small"
//                                 key={dataItem.id}
//                               >
//                                 <td>{dataItem.companyName}</td>

//                                 <td className="small-size">
//                                   {dataItem.address}
//                                 </td>
//                                 <td className="small-size">
//                                   {dataItem.contactNo}
//                                 </td>

//                                 <td>
//                                   <div className="small-size dt-status">
//                                     <span
//                                       className={`dt-status-dot ${
//                                         dataItem.isActive === 1
//                                           ? "dot-active"
//                                           : dataItem.status === "Blocked"
//                                           ? "dot-block"
//                                           : "dot-inactive"
//                                       }`}
//                                     ></span>
//                                     <span className="dt-status-text">
//                                       {dataItem.isActive === 1
//                                         ? "Active"
//                                         : "Block"}
//                                     </span>
//                                   </div>
//                                 </td>
                           
//                                 <td>{format(dataItem.expireDate,"yyyy/MM/dd")}</td>
//                                 <td className="dt-cell-action">
//                                   <div>
//                                     <button
//                                       className="delete-button btn btn-link px-2 m-0"
//                                       aria-label="view"
//                                       title="view"
//                                       style={{ color: "yellow" }}
//                                       onClick={() => handleView(dataItem.id)}
//                                     >

// <Eye color="#7a1fd6" />
//                                     </button>
//                                     <button
//                                       className="delete-button btn btn-link px-2 m-0"
//                                       aria-label="Delete"
//                                       title="Delete"
//                                       style={{ color: "blue" }}
//                                       onClick={(e) => {
//                                         setIsEdit(dataItem.id);
//                                       }}
//                                     >
//                                       <Pencil color="#19e631" />
//                                     </button>
//                                     <button
//                                       className="delete-button btn btn-link px-1 m-0"
//                                       aria-label="Delete"
//                                       title="Delete"
//                                       style={{ color: "red" }}
//                                     >
//                                       <Trash2 color="red" />
//                                     </button>
//                                   </div>
//                                 </td>
//                               </tr>
//                             );
//                           })}
//                         </tbody>
//                       </table>
//                     </div>
//                   </section>
    //            )
    (

      <section className="content-client-table">
              <div className=" table-responsive-sm scroll-y">
        <table className="table  table-striped table-hover mobile-table">
            <thead className="thead-light">
                <tr className="table-primary">
                    <th>Company</th>
                    {/* <th>Address</th> */}
                    <th>Contact</th>
                    <th width="20%" >Pan</th>
                 
                    {/* <th>Pcs</th> */}
                    <th>Expiry</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {records.map((client) => {
                    const expireDate = new Date(client.expireDate);
                    const remainingDays = Math.ceil((expireDate - currentDate) / (1000 * 60 * 60 * 24));
                    return (
                        <tr key={client.id}>
                            <td data-label="Company">{client.companyName}<span style={{ display: 'block' }}>{client.address}</span></td>
                            {/* <td data-label="Address">{client.address}</td> */}
                            <td data-label="Contact">{client.contactNo}</td>
                            <td width="20%" data-label="Pan">{client.panNo}</td>
                     
                            {/* <td data-label="PC">{client.totalPc}</td> */}
                            <td data-label="Expiry Date">{expireDate.toLocaleDateString()}</td>
                     
                            <td data-label="Actions">

                        
                           

<Eye  type="button"color="#7a1fd6"   onClick={() => handleView(client.id)}/>
                         
                       
                                  
                                      <Pencil type="button" color="#19e631" onClick={(e) => {
                                        setIsEdit(client.id);
                                      }}/>
                               
                                   
                                      <Trash2 type="button" color="red" />
                                  
                                  
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
        </div>
   </section>
    )}
              </div>
              <div
                className="tab-pane fade"
                id="faq_tab_2"
                role="tabpanel"
                aria-labelledby="faq_tab_2-tab"
              >
            
                <div className="p-3 scroll-y">
                  {filteredRecords?.map((item, index) => {
                    return (
                      <div key={index}>
                        <ActiveCompanyList record={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="faq_tab_3"
                role="tabpanel"
                aria-labelledby="faq_tab_3-tab"
              >
                <div className="p-3 scroll-y">
                  {filteredRecord.filter((record) => new Date(record.expireDate) < currentDate)?.map((item, index) => {
                    return (
                      <div key={index}>
                        <ActiveCompanyList record={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="faq_tab_4"
                role="tabpanel"
                aria-labelledby="faq_tab_4-tab"
              >
                <div className="p-3 scroll-y">
                  {BlockRecord?.map((item, index) => {
                    return (
                      <div key={index}>
                        <ActiveCompanyList record={item} />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyList;
